import { AlertProps } from "@mui/material/Alert/Alert";
import { Alert } from "@mui/material";
import React from "react";

export interface ConditionalMessageProps {
  condition: boolean;
  severity?: AlertProps["severity"];
  sx?: AlertProps["sx"];
  children: React.ReactNode;
}

export const ConditionalMessage = ({
                                     condition,
                                     severity = "info",
                                     sx,
                                     children,
                                   }: ConditionalMessageProps) => {
  if(!condition) {return null}

  const defaultSx: AlertProps["sx"]  = {
    display: "flex",
    alignItems: "center",
    mt: 15,
    px: 8,
    py: 0,
    position: "absolute",
    width: "100%",
    right: "0",
  }

  return(
    <Alert
      severity={severity}
      sx={sx ? ([defaultSx, sx] as AlertProps["sx"]) : defaultSx}
    >
      {children}
    </Alert>
  )
}
